var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"sorting-symbol"},[(_vm.order === 'asc')?[_vm._v("▴")]:(_vm.order === 'desc')?[_vm._v("▾")]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }